import { render, staticRenderFns } from "./Pmau.vue?vue&type=template&id=684b9bde&scoped=true&"
import script from "./Pmau.vue?vue&type=script&lang=js&"
export * from "./Pmau.vue?vue&type=script&lang=js&"
import style0 from "./Pmau.vue?vue&type=style&index=0&id=684b9bde&scoped=true&lang=css&"
import style1 from "./Pmau.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684b9bde",
  null
  
)

export default component.exports